import { API_URL } from "../config/config"
import { deleteRequest, postRequest } from "../utils/axiosUtils"

export const fileUpload = async (file, options = {}) => {
  if (!file) {
    throw new Error('File is required.')
  }

  const formData = new FormData()
  formData.append('file', file)

  Object.entries(options).forEach(([key, value]) => {
    formData.append(key, value)
  })

  const response = await postRequest({
    url: `${API_URL}/file/upload`,
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })

  if (response.status >= 200 && response.status < 300 && response.data) {
    return response.data?.data
  } else {
    const errorMessage = `Unexpected response code: ${response.status}`
    throw new Error(errorMessage)
  }
}

export const fileDelete = async (fileUrl) => {
  if (!fileUrl) {
    throw new Error('File URL is required for deletion.')
  }

  const response = await postRequest({
    url: `${API_URL}/file/deleteByUrl`,
    data: { url: fileUrl },
    headers: {
      'Content-Type': 'application/json',
    },
  })

  if (response.status >= 200 && response.status < 300 && response.data) {
    return response.data
  } else {
    const errorMessage = `Unexpected response code: ${response.status}`
    throw new Error(errorMessage)
  }
}